<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8">
                <card>
                    <div class="header">
                        <h4 v-if='userId' class="title">Edição de Usuário</h4>
                        <h4 v-else class="title">Novo Usuário</h4>
                    </div>
                    <div class="content">
                        <form @submit.prevent.stop="submit()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Nome</label>
                                        <input name="titulo" type="text" class="form-control border-input"
                                            v-model="user.name" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input name="titulo" type="email" class="form-control border-input"
                                            v-model="user.email" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Role</label>
                                        <select name="categoria" id="" class="form-control border-input"
                                            v-model="user.role">
                                            <option v-for="(role, index) in roles" :key="`categoria-${index}`"
                                                :value="role">
                                                {{ role }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="!userId">
                                    <div class="form-group">
                                        <label>Senha</label>
                                        <input name="titulo" type="password" autocomplete="new-password" class="form-control border-input"
                                            v-model="user.password" />
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-info btn-fill btn-wd">
                                    Salvar Usuário
                                </button>
                                <router-link class="btn btn-danger ml-2" to="/usuarios">Voltar</router-link>
                            </div>
                        </form>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>

import OverlayService from '../services/overlay-service';
import UsersService from '../services/users-service';
import { mapGetters } from 'vuex'
import AuthService from '../services/auth-service';

export default {
    components: {
    },

    computed: {
        ...mapGetters(['isSuperUser']),
    },

    watch: {
        $route(to, from) {
            this.userId = this.$route.params.id
            if (this.bookId) {
                this.loadUser()
            } else {
                this.user = this.newUser()
            }
        }
    },

    data() {
        return {
            roles: ['editor', 'desativado', 'admin', 'superuser'],
            userId: undefined,
            user: this.newUser()
        }
    },

    mounted() {

        this.userId = this.$route.params.id

        if (this.userId) {
            this.loadUser()
        }
    },

    methods: {
        newUser() {
            return {
                name: null,
                email: null,
                role: null
            }
        },

        update() {
            this.$forceUpdate()
        },

        loadUser() {
            OverlayService.trigger('show', true)

            UsersService.getOne(this.userId)
                .then((response) => response.data)
                .then((user) => { 

                    this.user = user

                }).finally(() => {
                    OverlayService.trigger('show', false)
                })
        },

        submit() {
            if (!this.userId) {
                this.create()
            } else {
                this.save()
            }
        },

        save() {
            OverlayService.trigger('show', true)
            UsersService.save(this.userId, this.user)
                .then(() => {
                    this.$alertify.success('Usuário salvo com sucesso')
                    OverlayService.trigger('show', false)
                })
                .catch((er) => {
                    const erro = (er.response || {}).data || {}

                    const mensagem = Object.keys(erro).map(key => erro[key]).join(', ')
                    this.$alertify.error(mensagem)
                }).finally(() => {
                    OverlayService.trigger('show', false)
                    this.$router.push('/usuarios')
                })
        },

        create() {
            OverlayService.trigger('show', true)

            this.user.username = this.user.email

            AuthService.register(this.user)
                .then((value) => {
                    this.$alertify.success('Usuário salvo com sucesso')
                    OverlayService.trigger('show', false)
                })
                .catch((er) => {
                    const erro = (er.response || {}).data || {}

                    const mensagem = Object.keys(erro).map(key => erro[key]).join(', ')
                    this.$alertify.error(mensagem)
                }).finally(() => {
                    OverlayService.trigger('show', false)
                    this.$router.push('/usuarios')
                })
        },
    }
}
</script>
